import { createContext, FC, PropsWithChildren, useContext } from 'react'

export type CatalogContextValue = {
    requestCatalogId: string
    memberCount?: number
}

const CatalogContext = createContext<CatalogContextValue | undefined>(undefined)

export const CatalogProvider: FC<PropsWithChildren<{ value: CatalogContextValue }>> = ({ value, children }) => {
    return <CatalogContext.Provider value={value}>{children}</CatalogContext.Provider>
}

export const useCatalog = (): CatalogContextValue => {
    const ctx = useContext(CatalogContext)
    if (!ctx) {
        throw new Error('useCatalog must be used within a CatalogProvider')
    }
    return ctx
}
